import clsx from 'clsx';
import { ReactNode } from 'react';

interface SectionProps {
  children?: ReactNode;
  first?: boolean;
  last?: boolean;
  className?: string;
}

/**
 * Used to divide form fields into 4 equal columns (1 when on mobile)
 * @param first when enabled the first child will take up 2 columns
 * @param last when enabled the last child will take up 2 columns
 * @param className additional classes to apply
 */
export function ModalSection({ children, first, last, className }: SectionProps) {
  return (
    <div
      className={clsx(
        'w-full grid md:grid-cols-4 md:gap-m',
        first && 'md:[&>*:first-child]:col-span-2',
        last && 'md:[&>*:last-child]:col-span-2',
        className
      )}
    >
      {children}
    </div>
  );
}
